import L from 'leaflet'

/**
 * Leaflet's default marker images 404 under bundlers (Vite/webpack) because the
 * library hard-codes relative image paths. Rather than wire up the image
 * imports, we use custom `divIcon`s — a colored dot — which also matches the
 * "red = online, grey = selected-offline" design and needs no image assets.
 */

const dotHtml = (color: string, ring: string, pulse: boolean) => `
  <span class="vmap-pin" style="--vmap-dot:${color}; --vmap-ring:${ring};">
    ${pulse ? '<span class="vmap-pin__pulse"></span>' : ''}
    <span class="vmap-pin__dot"></span>
  </span>
`

export const onlineIcon = L.divIcon({
  className: 'vmap-pin-wrap',
  html: dotHtml('#ef4444', 'rgba(239,68,68,0.35)', true),
  iconSize: [18, 18],
  iconAnchor: [9, 9],
  popupAnchor: [0, -10],
})

export const offlineIcon = L.divIcon({
  className: 'vmap-pin-wrap',
  html: dotHtml('#94a3b8', 'rgba(148,163,184,0.30)', false),
  iconSize: [18, 18],
  iconAnchor: [9, 9],
  popupAnchor: [0, -10],
})
